import { useMemo } from 'react';
import { type SellerRole } from '../../gql-operations/gql-generated';
import { useSellerRoles } from './useSellerRoles';

export const useSellerRole = (sellerRoleId?: string): SellerRole | null => {
    const sellerRoles = useSellerRoles();

    const sellerRole = useMemo(() => {
        if (!sellerRoleId) {
            return null;
        }
        return sellerRoles.find((role) => role.id === sellerRoleId) || null;
    }, [sellerRoles, sellerRoleId]);

    return sellerRole;
};
